import { useState, useEffect } from "react";

const usePermissionList = () => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    try {
      const storedPermissions = localStorage.getItem("permissions");
      if (storedPermissions) {
        const parsed = JSON.parse(storedPermissions);
        if (Array.isArray(parsed)) {
          setPermissions(parsed);
        } else {
          console.warn("❌ permissions JSON değil veya array değil:", parsed);
          setPermissions([]);
        }
      }
    } catch (error) {
      console.error("❌ permissions localStorage okunamadı:", error);
      setPermissions([]);
    }
  }, []);

  return permissions;
};

export default usePermissionList;
